import { JSX } from "react";

import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Checkbox, Box, Theme, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const getStyles = (theme: Theme) => ({
  container: { fontSize: theme.fontSizes.xs, fontWeight: theme.typography.fontWeightRegular },
  checkbox: { ":hover": { cursor: "default" } },
  icon: { color: theme.palette.primary.main },
});

function LiveSection(): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box sx={getStyles(theme).container}>
      <Checkbox
        icon={<RadioButtonUncheckedIcon sx={getStyles(theme).icon} />}
        checkedIcon={<RadioButtonCheckedIcon sx={getStyles(theme).icon} />}
        checked
        disableFocusRipple
        disableTouchRipple
        disableRipple
        sx={getStyles(theme).checkbox}
      />
      {t("Live Section")}
    </Box>
  );
}

export default LiveSection;
